import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { dialogStyles } from "../../../../../Constants/dialogStyles";
import {
  deleteButtonStyles,
  textButtonStyles,
} from "../../../../../Constants/buttonStyles";

const DeleteConfirmDailog = ({ onOpen, onClose, onConfirm, type }) => {
  return (
    <Dialog
      open={onOpen}
      onClose={onClose}
      PaperProps={{ sx: dialogStyles.dialogRoot }}
    >
      <DialogTitle sx={dialogStyles.dialogTitle}>
        Confirm {type} Removal
      </DialogTitle>
      <DialogContent dividers sx={dialogStyles.dialogContent}>
        <DialogContentText sx={dialogStyles.dialogContentText}>
          {type === "group"
            ? " Are you sure you want to delete this group? This action cannot be undone."
            : `Are you sure you want to remove this ${type} from the group? This action
          cannot be undone.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={dialogStyles.dialogActions}>
        <Button onClick={onClose} sx={textButtonStyles}>
          Cancel
        </Button>
        <Button onClick={onConfirm} sx={deleteButtonStyles} autoFocus>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDailog;
